import { PaletteMode, ThemeProvider } from '@mui/material';
import React, { createContext, useContext, useMemo, useState } from 'react';
import { ThatsTheTicketTheme, ThatsTheTicketDarkTheme } from '../themes';

type ThemeProviderProps = {
  children: React.ReactNode;
};

export const ColorModeContext = createContext({ setColorMode: (mode: PaletteMode) => {} });

function CustomThemeProvider({ children }: ThemeProviderProps) {
  const [mode, setMode] = useState<PaletteMode>('dark');

  const colorMode = useMemo(
    () => ({
      setColorMode: (mode: PaletteMode) => {
        setMode(mode);
      },
    }),
    [],
  );

  const theme = useMemo(
    () =>
      mode === "light" ? ThatsTheTicketTheme : ThatsTheTicketDarkTheme,
    [mode],
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export const useColorModeContext = () => {
  const context = useContext(ColorModeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export { CustomThemeProvider };